import { Fragment } from 'react';

import { IKnmPreview } from 'ApiPackage/SearchModule/interfaces/IKnmPreview';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG } from 'CorePackage/MainModule/constants/dateFormat';

import styles from './styles.module.scss';

interface IKnmViolationProps {
  passportData?: IKnmPreview;
}

export const KnmViolation = ({ passportData }: IKnmViolationProps) => (
  <div className={styles.ColumnContent}>
    {passportData?.objects?.map((obj, objIndex) => (
      <Fragment key={objIndex}>
        {obj.result &&
          obj.result.violations &&
          obj.result.violations.length > 0 &&
          obj.result.violations.map((violation, violationIndex) => (
            <Fragment key={violationIndex}>
              <span className={styles.SectionTitle}>
                {`Нарушение, связанное с результатом КНМ №${violationIndex + 1}`}
              </span>
              <div className={styles.Row}>
                <div className={styles.ColText}>Характер выявленного нарушения</div>
                <div className={styles.ColValue}>{violation.typeName}</div>
              </div>
              <div className={styles.Row}>
                <div className={styles.ColText}>
                  Сведения о выявленных нарушениях обязательных требований и требований, установленных муниципальными
                  правовыми актами, об их характере и о лицах, допустивших указанные нарушения (с указанием положений
                  правовых актов)
                </div>
                <div className={styles.ColValue}>{violation.note}</div>
              </div>

              {violation.legalBases && violation.legalBases.length > 0 && (
                <>
                  <span className={styles.SectionTitle}>Список положений нарушенных правовых актов.</span>
                  {violation.legalBases.map((lb, lbIndex) => (
                    <Fragment key={lbIndex}>
                      <span className={styles.SectionTitle}>
                        {`Положение нарушенного правового акта по выявленным нарушениям обязательных требований и требований, установленных муниципальными правовыми актами. №${
                          lbIndex + 1
                        }`}
                      </span>
                      {lb.atrDate && (
                        <div className={styles.Row}>
                          <div className={styles.ColText}>Дата нарушенного правового акта</div>
                          <div className={styles.ColValue}>
                            {formatDate({ date: lb.atrDate, dateFormat: DATE_FORMAT_LONG })}
                          </div>
                        </div>
                      )}
                      <div className={styles.Row}>
                        <div className={styles.ColText}>Номер нарушенного правового акта</div>
                        <div className={styles.ColValue}>{lb.atrNumber}</div>
                      </div>
                      <div className={styles.Row}>
                        <div className={styles.ColText}>Положение нарушенного правового акта</div>
                        <div className={styles.ColValue}>{lb.documentName}</div>
                      </div>
                      <div className={styles.Row}>
                        <div className={styles.ColText}>Тип нарушенного правового акта</div>
                        <div className={styles.ColValue}>{lb.typePointingName}</div>
                      </div>
                    </Fragment>
                  ))}
                </>
              )}
              {violation.injunctions && violation.injunctions.length > 0 && (
                <>
                  <span className={styles.SectionTitle}>
                    Список сведений о выданных предписаниях об устранении выявленных нарушений
                  </span>
                  {violation.injunctions.map((injunction, injunctionIndex) => (
                    <Fragment key={injunctionIndex}>
                      <span className={styles.SectionTitle}>
                        {`Сведения о выданных предписаниях об устранении выявленных нарушений и (или) о проведении мероприятий по предотвращению причинения вреда (реквизиты, срок выполнения, содержание предписания) №${
                          injunctionIndex + 1
                        }`}
                      </span>
                      {injunction.code && (
                        <div className={styles.Row}>
                          <div className={styles.ColText}>
                            Реквизиты предписания об устранении выявленных нарушений в результате проведения КНМ
                          </div>
                          <div className={styles.ColValue}>{injunction.code}</div>
                        </div>
                      )}
                      {injunction.appointmentDate && (
                        <div className={styles.Row}>
                          <div className={styles.ColText}>
                            Дата вынесения предписания об устранении выявленных нарушений в результате проведения КНМ
                          </div>
                          <div className={styles.ColValue}>
                            {formatDate({ date: injunction.appointmentDate, dateFormat: DATE_FORMAT_LONG })}
                          </div>
                        </div>
                      )}
                      {injunction.executionDeadline && (
                        <div className={styles.Row}>
                          <div className={styles.ColText}>
                            Срок выполнения предписания об устранении выявленных нарушений в результате проведения КНМ
                          </div>
                          <div className={styles.ColValue}>
                            {formatDate({ date: injunction.executionDeadline, dateFormat: DATE_FORMAT_LONG })}
                          </div>
                        </div>
                      )}
                      {injunction.note && (
                        <div className={styles.Row}>
                          <div className={styles.ColText}>
                            Содержание предписания об устранении выявленных нарушений в результате проведения КНМ
                          </div>
                          <div className={styles.ColValue}>{injunction.note}</div>
                        </div>
                      )}
                      {injunction.refused !== null && (
                        <div className={styles.Row}>
                          <div className={styles.ColText}>
                            Отметка о невыполнении предписания об устранении выявленных нарушений в результате
                            проведения КНМ
                          </div>
                          <div className={styles.ColValue}>{injunction.refused ? 'Да' : 'Нет'}</div>
                        </div>
                      )}
                    </Fragment>
                  ))}
                </>
              )}
              {violation.lawsuits && violation.lawsuits.length > 0 && (
                <>
                  <span className={styles.SectionTitle}>Список судебных сведений о выявленных нарушениях</span>
                  {violation.lawsuits.map((lawsuit, lawsuitIndex) => (
                    <Fragment key={lawsuitIndex}>
                      <span className={styles.SectionTitle}>
                        {`Судебные сведения о выявленных нарушениях №${lawsuitIndex + 1}`}
                      </span>
                      <div className={styles.Row}>
                        <div className={styles.ColText}>
                          Тип судебных сведений о выявленных нарушениях в результате проведения КНМ
                        </div>
                        <div className={styles.ColValue}>{lawsuit.typeName}</div>
                      </div>
                      <div className={styles.Row}>
                        <div className={styles.ColText}>Формулировка судебного сведения</div>
                        <div className={styles.ColValue}>{lawsuit.text}</div>
                      </div>
                    </Fragment>
                  ))}
                </>
              )}
            </Fragment>
          ))}
      </Fragment>
    ))}
  </div>
);
